<template>
  <div>
    <a-page-header
      class="page-header"
      :ghost="false"
      style="margin-bottom: 16px"
    >
      <template #title>
        <a-space size="middle">
          <a-icon type="compass"></a-icon>
          <span>信息归集</span>
        </a-space>
      </template>
      <span>信息归集用于漏洞扫描/渗透测试自动化生成工单。</span>
    </a-page-header>
    <div
      style="
        background: #fff;
        border-radius: 8px;
        padding: 24px;
        box-shadow: rgba(0, 0, 0, 0.08) 0p  x 0px 8px;
        position: relative;
      "
    >
      <div style="max-width: 900px; margin-left: 60px">
        <a-form-model
          ref="form"
          :model="form"
          :rules="rules"
          :label-col="{
            span: 3,
            style: {
              textAlign: 'left'
            }
          }"
          :wrapperCol="{ span: 21 }"
        >
          <a-form-model-item label="归集类型" prop="collectType">
            <a-select
              v-model="form.collectType"
              :options="collectTypeOptions"
            ></a-select>
          </a-form-model-item>
          <a-form-model-item label="文件" prop="fileList">
            <a-upload-dragger
              accept=".doc,.docx,.xls,.xlsx"
              :before-upload="beforeUpload"
              :file-list="form.fileList"
              :multiple="true"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox" />
              </p>
              <p class="ant-upload-text">点击或拖拽文件到本区域</p>
              <p class="ant-upload-hint">支持扩展名：.doc .docx .xls .xlsx...</p>
            </a-upload-dragger>
          </a-form-model-item>
          <a-form-model-item
            :wrapper-col="{ span: 21, offset: 3 }"
            style="margin: 24px 0 0 0"
          >
            <a-space size="middle">
              <a-button type="primary" :loading="loading" @click="ok">确定</a-button>
              <a-button @click="clear">重置</a-button>
            </a-space>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import { createServiceSecurityITSM } from '@/api/itsm'

export default {
  name: 'InformationCollection',
  data () {
    return {
      form: {
        collectType: 'vulnerability_scan',
        fileList: []
      },
      rules: {
        collectType: [{
          message: '请选择工单类型',
          required: true,
          trigger: 'change'
        }],
        fileList: [{
          message: '请上传文件',
          required: true,
          trigger: 'change'
        }]
      },
      collectTypeOptions: [
        { title: '漏洞扫描', value: 'vulnerability_scan' },
        { title: '渗透测试', value: 'penetration_test' }
      ],
      loading: false
    }
  },
  methods: {
    beforeUpload (file) {
      this.form.fileList.push(file)
      return false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = new FormData()
          params.append('collect_type', this.form.collectType)
          this.form.fileList.forEach(file => {
            params.append('files', file)
          })
          createServiceSecurityITSM(params)
            .then(res => {
              this.$message.success(res.message)
              this.$refs.form.resetFields()
              this.fetch()
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    clear () {
      this.form = {
        name: '',
        collectType: 'vulnerability_scan',
        fileList: undefined
      }
    }
  }
}
</script>
